'use strict';

var Actions = require('../actions/ActivityServerActionCreators'),
    { get: get, del } = require('../utils/APIUtils');

var ActivityAPI = {
  requestActivitiesPage(url) {
    url = url || '/api/user/activities';
    get(url, Actions.handleActivitiesPage);
  },

  requestUnseenCount() {
    get('/api/user/activities/unseen', Actions.handleUnseenCount);
  },

  markAll() {
    del('/api/user/activities/unseen', Actions.handleMarkAll);
  }
};

module.exports = ActivityAPI;


/** WEBPACK FOOTER **
 ** ./api/ActivityAPI.js
 **/